function getProductInventoryDelivery(config, availability) {
  const missingDeliveryDays = config.missingInventoryChannelStrategy.expectedDeliveryDays;
  if (typeof availability === "undefined") {
    return missingDeliveryDays;
  }
  const availableChannels = availability.channels || {};
  const channels = Object.entries(availableChannels);
  if (!channels.length) {
    return missingDeliveryDays;
  }
  const ONLINE_STORE = "online-store";
  const [channelId, channel] = channels.find((channel2) => channel2[1].key === ONLINE_STORE) || channels[0];
  const channelDeliveryConfig = channel?.key && config.inventoryChannels?.[channel.key] || config.inventoryChannels[channelId];
  if (!channelDeliveryConfig) {
    console.error(`Inventory channel ${channel.key || channelId} is not configured.`);
    return missingDeliveryDays;
  }
  if (typeof channel.availableQuantity === "undefined") {
    return missingDeliveryDays;
  }
  const stockKey = channel.availableQuantity > 0 ? "onStock" : "outOfStock";
  return channelDeliveryConfig.expectedDeliveryDays[stockKey];
}
export {
  getProductInventoryDelivery
};
//# sourceMappingURL=get-product-inventory-delivery.js.map
